import alunara1 from "./Alunara.png";
import alunara2 from "./Alunara (2).png";
import alunara3 from "./Alunara (3).png";

const Alunara = [alunara1, alunara2, alunara3];

export default Alunara;
